import { render, staticRenderFns } from "./AccountUpdateEmail.vue?vue&type=template&id=18168642"
import script from "./AccountUpdateEmail.vue?vue&type=script&lang=js"
export * from "./AccountUpdateEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports